import { EVENTS_CONSTANTS, LOCATION_IDS } from "config/constants";
import { requestGetTeacherZoomAccountDetail } from "services/events/relatedToEvents";

const { FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE } = EVENTS_CONSTANTS;

const useTeacherZoomAccountDetailRequest = ({
    loadingRequest,
    teacherZoomAccountDetail,
    changeErrorText,
    changeFieldPart1,
    errors, form
}) => {
    const fillTeacherZoomAccountDetail = async ({
		teacher = {
			teacherAccountId: form.part1.teacher.free.accountId || null,
			teacherId: form.part1.teacher.search.id || null,
		},
		locationId = form.part2.locationId,
	}) => {
		if (
			locationId !== LOCATION_IDS.ZOOM ||
			(!teacher.teacherAccountId && !teacher.teacherId)
		)
			return;
		loadingRequest.show("Buscando detalle de cuenta...");
		const newTeacherZoomAccountDetail =
			await requestGetTeacherZoomAccountDetail(teacher);
		loadingRequest.hide();
		teacherZoomAccountDetail.set(newTeacherZoomAccountDetail);
	};
    const isActiveTeacherZoomAccount = () => {
		const { state } = teacherZoomAccountDetail.value;
		const errorText =
            FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE[
				state
			];
		if (!errorText) return true;
		changeErrorText("teacherSearch", errorText);
		changeFieldPart1("teacher", form.part1.teacher, {
			...errors.part1.teacher,
			search: true,
		});
		return false;
	};
    return {
        fillTeacherZoomAccountDetail,
        isActiveTeacherZoomAccount
    };
}	
    
export default useTeacherZoomAccountDetailRequest;